import {TextArea} from 'devextreme-react/text-area';
import {formatDate} from 'devextreme/localization';
import {useContext,} from 'react';
import {Link} from 'react-router-dom';
import {Field, Panel} from '../../../../layouts';
import {WorkOrderContext} from '../context/WorkOrderContext';

export default function WorkOrderInformationPanel() {

	const { order } = useContext(WorkOrderContext);

	return (
		<>
			<Panel
				header={'Work Order Information'}
			>
				<Field label={'Work Order #'} showCopyToClipboard={true} >{order.details.woNumber}</Field>
				<Field label={'Order Status'} >{order.details.orderStatus}</Field>
				<Field label={'Order Date'} >{formatDate(new Date(order.details.woDate), 'shortDate')}</Field>
				<Field label={'WO Creation Date'} >{formatDate(new Date(order.details.createdOn), 'shortDate')}</Field>
				<Field label={'Project #'} >{order.details.projectNumber}</Field>
				<Field label={'Originating RO #'} >
					<Link to={'/cfi/retail-order/' + order.details.originatingROID + '?returnUrl=' + encodeURIComponent('/cfi/orders/retail-orders')}>
						{order.details.originatingRO}
					</Link>
				</Field>
				<Field label={'Description'} vertical={true} >
					<TextArea height={100} value={order.details.description} readOnly={true} ></TextArea>
				</Field>
			</Panel>
		</>
	);
}
